import companyService from '../../services/companyService'

class UnsubscribeForm {
  onSubmit = async ({ companyId }: { companyId: string }): Promise<void> => {
    await companyService.updateStripePaymentMethod({ companyId, stripePaymentMethodId: null })
  }
}

export default new UnsubscribeForm()
